// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__9TO7q","active":"Uploader_active__2Z7I4"};